import { render } from "./InternalTransferRequests.vue?vue&type=template&id=0c97bcda&ts=true"
import script from "./InternalTransferRequests.vue?vue&type=script&lang=ts"
export * from "./InternalTransferRequests.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__